module.exports = __webpack_public_path__ + "img/recovery-convert.71f9616a.svg";